import { Link, useNavigate } from "react-router";
import { Home, ArrowLeft, SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "motion/react";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 min-h-screen bg-slate-50 flex items-center justify-center p-4 relative overflow-hidden font-sans">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[10%] -left-[10%] w-[40%] h-[40%] rounded-full bg-linear-to-br from-blue-100 to-indigo-100 blur-3xl opacity-50 animate-pulse" />
        <div className="absolute top-[60%] -right-[10%] w-[50%] h-[50%] rounded-full bg-linear-to-tl from-sky-100 to-blue-50 blur-3xl opacity-50" />

        {[...Array(6)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full bg-blue-500/10"
            style={{
              width: Math.random() * 40 + 10,
              height: Math.random() * 40 + 10,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -30, 0],
              x: [0, Math.random() * 20 - 10, 0],
              scale: [1, 1.2, 1],
            }}
            transition={{
              duration: Math.random() * 3 + 4,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 10 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 max-w-lg w-full text-center space-y-8 p-10 bg-white/60 backdrop-blur-2xl rounded-[2.5rem] shadow-[0_20px_40px_-15px_rgba(0,0,0,0.05)] border border-white/80"
      >
        <div className="relative mx-auto w-32 h-32 flex items-center justify-center">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            className="absolute inset-0 rounded-full border-2 border-dashed border-indigo-200"
          />
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 15,
              delay: 0.2,
            }}
            className="relative w-20 h-20 bg-linear-to-br from-indigo-500 to-blue-600 text-white rounded-2xl flex items-center justify-center shadow-lg shadow-indigo-200 rotate-12"
          >
            <SearchX className="w-10 h-10 -rotate-12" />
          </motion.div>
        </div>

        <div className="space-y-3">
          <h1 className="text-[120px] leading-none font-black text-transparent bg-clip-text bg-linear-to-br from-slate-800 to-slate-400 tracking-tighter">
            404
          </h1>
          <h2 className="text-2xl font-bold text-slate-800 tracking-tight">
            Halaman Tidak Ditemukan
          </h2>
          <p className="text-slate-500 text-base max-w-sm mx-auto leading-relaxed">
            Oops! Tampaknya Anda tersesat. Halaman yang Anda tuju mungkin sudah
            dihapus atau URL-nya salah.
          </p>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="w-full sm:w-auto rounded-xl h-12 px-6 font-semibold border-slate-200 hover:bg-slate-50 text-slate-600 transition-all"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Kembali
          </Button>
          <Button
            asChild
            className="w-full sm:w-auto rounded-xl h-12 px-8 font-semibold bg-indigo-600 hover:bg-indigo-700 text-white shadow-md shadow-indigo-200 transition-all hover:-translate-y-0.5"
          >
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              Ke Beranda
            </Link>
          </Button>
        </div>
      </motion.div>
    </div>
  );
}
